export default "__VITE_ASSET__ADwBZg2r__"